module.exports = __webpack_public_path__ + "img/best-before.4ecad10d.svg";